module.exports = __webpack_public_path__ + "static/media/basemap_cardo_db.bf2ef490.png";